module.exports = __webpack_public_path__ + "img/image-deco.65914dfd.png";